<template>
  <router-view />
</template>

<script>
export default {
  created() {
    this.$store.dispatch("commonStore/FETCH_CONTACT_INFO");
  },
};
</script>
<style scoped>
@import "@/assets/css/styles.css";
</style>